export default __webpack_public_path__ + "static/media/min-contour-icon.fa4b0b63.svg";